import React from "react";

import {
    Backdrop,
    Box,
    Button,
    Stack,
    Typography
} from "@mui/material";

import { Trans } from "@lingui/macro";
import { Login } from "@mui/icons-material";
import { Link } from "react-router-dom";

export default class GeoBlockedModal extends React.Component<{}, {}> {

    render() {
        return (<Backdrop
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1
            }}
            open={true}>
            <Box
                style={{
                    border: "2px solid " + process.env.REACT_APP_SECONDARY_COLOR,
                    minWidth: "350px",
                    minHeight: "200px",
                    padding: "25px",
                    textAlign: "center",
                    position: "fixed",
                    bottom: "50%"
                }}>
                <Stack spacing={1}>
                    <Typography variant="h2" color={process.env.REACT_APP_PRIMARY_COLOR}>
                        <Trans id="pm-mandatory-geoblock-title">
                            Contenuto non disponibile
                        </Trans>
                    </Typography>
                    <Typography variant="body1" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                        <Trans id="pm-mandatory-geoblock-text">
                            Il contenuto selezionato non è disponibile nel tuo paese
                        </Trans>
                    </Typography>
                    <Link to={"/login"}>
                        <Button variant="outlined" startIcon={<Login />}>
                            <Trans id="pm-modal-login">
                                Login
                            </Trans>
                        </Button>
                    </Link>
                </Stack>
            </Box>

        </Backdrop>);
    }
}
